import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {JackpotService} from '@myServices/jackpot.service';
import {AuthenticationService, NotificationService} from '@Shared/services';
import {Subscription} from 'rxjs/Subscription';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
    selector: 'app-jackpots-header',
    templateUrl: './jackpots-header.component.html',
    styleUrls: ['./jackpots-header.component.css']
})
export class JackpotsHeaderComponent implements OnInit, OnDestroy {


    @Input() data;
    public jackpotInfo: any = null;
    private subscriptions: Subscription[] = [];
    constructor(private jackpotService: JackpotService,
                private authService: AuthenticationService,
                private notificationService: NotificationService) {
    }

    ngOnInit() {
        this.initJackpotAmounts();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    initJackpotAmounts() {
        // todo block dublicates
        const jackpotSubscr = this.jackpotService.getJackpots.subscribe((resp) => {
            if (this.jackpotService.isJackpotEnabled) {
                this.jackpotInfo = {
                    ...resp,
                    translates: {diamondJackpot: 'DIAMOND_JACKPOT', goldJackpot: 'GOLD_JACKPOT', bronzeJackpot: 'BRONZE_JACKPOT'},
                    iconSrc: {
                        diamondJackpot: '../../assets/images/icons/diamond_jackpot.png',
                        goldJackpot: '../../assets/images/icons/gold_jackpot.png',
                        bronzeJackpot: '../../assets/images/icons/bronze_jackpot.png'
                    }
                };
            }
        }, error => {
            console.log(error);
            this.notificationService.error(error);
        });
        this.subscriptions.push(jackpotSubscr);

        const jackpotWinsSubscr = this.jackpotService.getJackpotWins.subscribe((jackpotWins) => {
            if (jackpotWins && jackpotWins.length > 0) {
                jackpotWins.forEach((win) => {
                    if (!sessionStorage.getItem('jackpot_win_' + win.id)) {
                        sessionStorage.setItem('jackpot_win_' + win.id, JSON.stringify({showed: true}));
                        this.showJackpotWinAlert(win, this.authService.getCurrentUser());
                    }
                });
            }
        }, error => {
            console.log(error);
            this.notificationService.error(error);
        });
        this.subscriptions.push(jackpotWinsSubscr);
    }

    public showJackpotWinAlert(win , user) {
        let titleMessage = `Someone else won '${win.jackpot_pool.jackpot.name}' jackpot. Keep playing for Jackpot`;
        let textMessage = '';
        let iconType = 'warning';
        if (win.player_id == user.id) {
            titleMessage = `You're in luck. You won '${win.jackpot_pool.jackpot.name}' Jackpot`;
            textMessage = `you won ${win.amount} ${user.currency}`;
            iconType = 'success';
        }
        // Todo integrate sweetalert2
        swal({
            icon: iconType,
            title: titleMessage,
            text: textMessage,
            timer: 30000,
            closeOnClickOutside: false,
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/jackpots-header/jackpots-header.component.ts